module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/catalogo-lista-default/catalogo-lista-default.component.scss
// module id = ./src/app/components/partials/catalogo-lista-default/catalogo-lista-default.component.scss
// module chunks = main